// Valores aceitos pelo back em GET /exchange/search-orders (Exchange::SEARCH_TYPE_*).
export const EXCHANGE_SEARCH_TYPE = Object.freeze({
  EMAIL: '1',
  DOCUMENT: '2',
  SERIAL: '3',
  ORDER: '4',
})

// Tipos em que o cliente é conhecido antes da busca: o sync usa o valor digitado.
export const CUSTOMER_SEARCH_TYPES = Object.freeze([
  EXCHANGE_SEARCH_TYPE.EMAIL,
  EXCHANGE_SEARCH_TYPE.DOCUMENT,
])

// Na ordem em que aparecem no select.
export const EXCHANGE_SEARCH_OPTIONS = Object.freeze([
  { value: EXCHANGE_SEARCH_TYPE.EMAIL, text: 'E-mail', label: 'E-mail', placeholder: 'Ex: exemplo@email.com' },
  { value: EXCHANGE_SEARCH_TYPE.DOCUMENT, text: 'CPF', label: 'CPF', placeholder: 'Ex: 111.111.111-11' },
  { value: EXCHANGE_SEARCH_TYPE.ORDER, text: 'Nº Pedido', label: 'Número do Pedido (AD_PEDIDO / NUMNOTA)', placeholder: 'Ex: 123456' },
  { value: EXCHANGE_SEARCH_TYPE.SERIAL, text: 'SN (Série)', label: 'Número de Série', placeholder: 'Ex: 2100...' },
])
